import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=98346d6a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98346d6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98346d6a')) {
      api.createRecord('98346d6a', component.options)
    } else {
      api.reload('98346d6a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=98346d6a&scoped=true&", function () {
      api.rerender('98346d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hZoESXrzHaqi/JS/comp/Accordion.vue"
export default component.exports